module.exports = {


  footerText: '',
  version: ''

};
